import {
  ONBOARDING_V1_STEP_IDS,
  OnboardingV1StepSchema,
  type OnboardingV1Step,
} from "@repo/types";

export const ONBOARDING_STEP_IDS = ONBOARDING_V1_STEP_IDS;
export type OnboardingV1StepId = OnboardingV1Step;

export interface OnboardingV1StepSearch {
  readonly step?: Exclude<OnboardingV1StepId, "hook">;
}

export function parseOnboardingV1StepId(
  value: unknown,
): OnboardingV1StepId | null {
  const parsed = OnboardingV1StepSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}

export function normalizeOnboardingV1StepId(
  value: unknown,
): OnboardingV1StepId {
  return parseOnboardingV1StepId(value) ?? "hook";
}

export function normalizeOnboardingV1StepSearch(
  search: Record<string, unknown>,
): OnboardingV1StepSearch {
  const step = normalizeOnboardingV1StepId(search.step);
  return step === "hook" ? {} : { step };
}

export function getOnboardingV1StepIndex(step: OnboardingV1StepId): number {
  return ONBOARDING_STEP_IDS.indexOf(step);
}
